import React, {useEffect} from 'react';
import LoginUser from './../pages/auth/login/LoginPage'
//import { Redirect } from 'react-router-dom';

import { useDispatch/*, useSelector*/ } from 'react-redux';
import withReducer from 'app/store/withReducer';
import reducer from 'app/auth/store/reducers';
import * as Actions from 'app/store/actions';


import { useHistory } from 'react-router-dom';

function Login() {
	const dispatch = useDispatch();
	const history = useHistory();
	//const connectedUser = useSelector(({ user }) => user.user);
	//const projectSelectAPILoginData = useSelector(({ LoginApp }) => LoginApp.login.projectSelectAPILogin);

	useEffect(() => {
		document.title = "Login | SCAI";
	}, [])

	let cu = localStorage.getItem('current_user')
	const currentUser = JSON.parse(cu);
	const sessionData = {
		sessionId: '',
		token: ''
	};


	//::RE-DIRECT TO DASHBOARD IF ONLY HAS ONE PROJECT
	const projectSelectAPI = currentUser?.userProjectData;
	
	//::CHECKING IF HAS ONLY CTM PROJECTS
	function isCTM(ctm) {
		return ctm === 'c6a22e66-db0d-4c59-9c27-7dcb9888150e'; //CTM UUID
	}
	const typeOfProjects = projectSelectAPI?.map(list => list?.project_type?.uuid);
	const onlyCTM = typeOfProjects?.length !==0 && typeOfProjects?.every(isCTM);

	useEffect(()=>{
		if(projectSelectAPI){
			//if(prevState !== projectSelectAPI?.length){

			//::CHECKING IF HAS ONLY CTM PROJECTS
			if(onlyCTM){
				//alert('ONLY CTM')
				if(projectSelectAPI.length === 1){
					//::Selecting Project
					localStorage.setItem('persistProjectSelected', JSON.stringify(projectSelectAPI?.[0]));
					localStorage.setItem('persistProjectUUID', projectSelectAPI?.[0]?.uuid);
					dispatch(Actions.handleMembers_projectSelected(projectSelectAPI?.[0]));
					dispatch(Actions.members_selectedProjectName(projectSelectAPI?.[0]?.projectName));
					dispatch(Actions.getMembers(localStorage.getItem('persistCompanyID'), projectSelectAPI?.[0]?.uuid));
					dispatch(Actions.getSideMenuItems());
					dispatch(Actions.getNoticeBoard());



				}
					//Redirect to CTM PAGE
					history.push({pathname:'/ctm'})
			}else{
				if(projectSelectAPI?.length === 1){

					//::Selecting Project
					localStorage.setItem('persistProjectSelected', JSON.stringify(projectSelectAPI?.[0]));
					localStorage.setItem('persistProjectUUID', projectSelectAPI?.[0]?.uuid);
					dispatch(Actions.handleMembers_projectSelected(projectSelectAPI?.[0]));
					dispatch(Actions.members_selectedProjectName(projectSelectAPI?.[0]?.projectName));
					dispatch(Actions.getMembers(localStorage.getItem('persistCompanyID'), projectSelectAPI?.[0]?.uuid));
					dispatch(Actions.getSideMenuItems());
					dispatch(Actions.getNoticeBoard());



					// setTimeout(()=>{
					// 	dispatch(Actions.getSideMenuItems());
					// },500);

					//Redirect to DASHBOARD
					history.push({pathname:'/project-info'});
				}
				else if(projectSelectAPI?.length === 0){
					history.push({pathname:'/chat'});
				}else{
					history.push({pathname:'dashboard/map'});
				}
			}
	
		}

		currentUser && currentUser.uuid && 
		
			console.log('user just logged in')
			
			//user just logged, add information in localStorage
			localStorage.setItem('calling', JSON.stringify(currentUser && currentUser.call_progress));
			localStorage.setItem('callingSession', JSON.stringify(sessionData) );
			localStorage.setItem('initialStatus', "online" );


	// eslint-disable-next-line react-hooks/exhaustive-deps
	},[currentUser]);

	

	return (
		!currentUser?.uuid && <LoginUser />
	);
}

//export default Login;
export default React.memo(withReducer('LoginApp', reducer)(Login));
